(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.layout = window.oneadvanced.layout || {};
    window.oneadvanced.layout.initFullFlushColumns = function () {
        //console.log("initialising layout initFullFlushColumns...");
        if (window.location.search.indexOf("epieditmode") >= 0) {
            return;
        }

        resizeFullFlushColumns();

        function firstLastBlock() {
            var $mainContent = $('.main-content');
            if ($mainContent.length) {
                $mainContent.each(function () {
                    $(this).find('> .block').first().addClass('first-block');
                    $(this).find('> .block').last().addClass('last-block');
                });
            }
        }

        function resizeFullFlushColumns() {
            $('.main-body .block.full-flush').each(function () {
                var $rowDiv = $('<div class="main-content grid-x grid-margin-x grid-margin-y align-middle">'),
                    $containerDiv = $('<div class="grid-container">'),
                    $block = $(this);

                $block.unwrap('.main-content').unwrap('.grid-container');
                $($block.prevAll().not('.grid-container, .full-flush').toArray().reverse()).wrapAll($containerDiv).wrapAll($rowDiv);
                $block.nextUntil('.full-flush').wrapAll($containerDiv).wrapAll($rowDiv);
            });

            firstLastBlock();
        }
    };
    window.oneadvanced.layout.hasLoaded = true;

})();